import { Link } from 'react-router-dom';
import type { HighLevelIssue } from '../types/content';
import { countHighLevelItems } from '../lib/contentUtils';
import { CategoryImage } from './CategoryImage';

const ACCENTS = ['accent-crimson', 'accent-gold', 'accent-teal', 'accent-slate'];

interface HighLevelIssueCardProps {
  issue: HighLevelIssue;
  index: number;
  /** Home cards use imagery; explore keeps text descriptions. */
  variant?: 'visual' | 'standard';
}

export function HighLevelIssueCard({
  issue,
  index,
  variant = 'standard',
}: HighLevelIssueCardProps) {
  const accent = ACCENTS[index % ACCENTS.length];
  const itemCount = countHighLevelItems(issue);

  if (variant === 'visual') {
    return (
      <Link to={`/issues/${issue.slug}`} className={`section-card section-card-visual ${accent}`}>
        <div className="section-card-media">
          <CategoryImage issue={issue} className="section-card-image" decorative eager />
          <div className="section-card-media-overlay">
            <h3>{issue.title}</h3>
          </div>
        </div>
        <div className="section-card-footer">
          <span>{issue.specificIssues.length} subtopics</span>
          <span>{itemCount} entries</span>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/issues/${issue.slug}`} className={`section-card ${accent}`}>
      <span className="section-card-label">{issue.specificIssues.length} subtopics</span>
      <h3>{issue.title}</h3>
      <p>{issue.voterFacingSummary}</p>
      <div className="section-card-footer">
        <span>{itemCount} related entries</span>
        <span className="section-card-source">Explore →</span>
      </div>
    </Link>
  );
}
